import { FilterCommonTypes } from '../types-store';
import { CustomFilterType, FilterConfiguration } from './types';
import {
  codeFilter, codeWithoutExcludeFilter, codeHierarchyFilter, codeHierarchySubLevelFilter, codeHierarchyParentsFilter,
  inputIntegerFilter, inputIntegerWithoutExcludeFilter, dateFilter, dateRangeFilter, dateSpecificPeriodFilter, checkboxFilter,
  textFilter, decimalRangeFilter, defaultValueSingleHierarchy, defaultValueMultiple, defaultValueMultipleSubLevel,
  codeHierarchySubLevelWithCategoryHierarchical, codeHierarchySubLevelWithCategory, defaultValueSingleHierarchyParents
} from './constants';

export const typeMapping: { [key: string]: FilterConfiguration<FilterCommonTypes> } = {
  [CustomFilterType.code]: codeFilter,
  [CustomFilterType.codeWithoutExclude]: codeWithoutExcludeFilter,
  [CustomFilterType.codeHierarchy]: codeHierarchyFilter,
  [CustomFilterType.codeHierarchySubLevel]: codeHierarchySubLevelFilter,
  [CustomFilterType.codeHierarchySubLevelWithCategoryHierarchical]: codeHierarchySubLevelWithCategoryHierarchical,
  [CustomFilterType.codeHierarchySubLevelWithCategory]: codeHierarchySubLevelWithCategory,
  [CustomFilterType.codeHierarchyParents]: codeHierarchyParentsFilter,
  [CustomFilterType.defaultValueSingleHierarchy]: defaultValueSingleHierarchy,
  [CustomFilterType.defaultValueSingleHierarchyParents]: defaultValueSingleHierarchyParents,
  [CustomFilterType.defaultValueMultiple]: defaultValueMultiple,
  [CustomFilterType.defaultValueMultipleSubLevel]: defaultValueMultipleSubLevel,
  [CustomFilterType.checkbox]: checkboxFilter,
  [CustomFilterType.inputIntegerFilter]: inputIntegerFilter,
  [CustomFilterType.inputIntegerWithoutExclude]: inputIntegerWithoutExcludeFilter,
  [CustomFilterType.date]: dateFilter,
  [CustomFilterType.dateRange]: dateRangeFilter,
  [CustomFilterType.dateSpecificPeriod]: dateSpecificPeriodFilter,
  [CustomFilterType.text]: textFilter,
  [CustomFilterType.decimalRange]: decimalRangeFilter
};
